<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" [text]="'core.backButton' | translate"></ion-back-button>
    </ion-buttons>
    <ion-title>{{ canteenService.getLocalizedString(canteen().name) }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="selectCanteen()" [attr.aria-label]="'canteen.select' | translate">
        <ion-icon slot="icon-only" name="list"></ion-icon>
      </ion-button>
      <ion-button (click)="openDishInformation()" [attr.aria-label]="'canteen.additives' | translate">
        <ion-icon slot="icon-only" name="information-circle"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar color="primary">
    <div class="quiver-left">
      <ion-icon class="arrow" [class.arrow-invisible]="isIOS() || !showLeftArrow()" name="arrow-back"></ion-icon>
    </div>

    <ion-segment
      #weekdaySegment
      (scroll)="scrollHandler($event)"
      [scrollable]="true"
      [value]="selectedIndex()"
      (ionChange)="weekdaySelected($event)"
      >
      @for (weekday of weekdays(); track weekday; let i = $index) {
        <ion-segment-button [value]="i" layout="icon-start">
          @if (todayIndex() === i) {
            <ion-icon name="calendar"></ion-icon>
          }
          <ion-label>
            {{ canteenService.getLocalizedString(weekday) }}
          </ion-label>
        </ion-segment-button>
      }
    </ion-segment>

    <div class="quiver-right">
      <ion-icon class="arrow" [class.arrow-invisible]="isIOS() || !showRightArrow()" name="arrow-forward"></ion-icon>
    </div>
  </ion-toolbar>
  @if (isToday()) {
    @if(isOpen() !== null) {
      @if (isOpen()) {
        <ion-toolbar color="primary" class="openings ion-text-wrap">
          <ion-label>
            {{ 'canteen.open' | translate }}
            @if (nextOpeningTransition) {
              <span>. {{ 'canteen.closesIn' | translate }} {{ nextOpeningTransition | openings }}</span>
            }
          </ion-label>
        </ion-toolbar>
      } @else {
        <ion-toolbar color="danger" class="openings ion-text-wrap">
          <ion-label>
            @if (nextOpeningTransition) {
              {{ 'canteen.closed' | translate }}. {{ 'canteen.opens' | translate }} {{ nextOpeningTransition | openings }}
            } @else {
              {{ 'canteen.closed' | translate }}
            }
          </ion-label>
        </ion-toolbar>
      }
    }
  }
</ion-header>

<ion-content>
  <swiper-container #swiper (swiperslidechange)="onSwipe($event)">
    @for (weekday of weekdays(); track weekday) {
      <swiper-slide>
        <ion-list>
          @for (dish of weekday.dishes; track dish) {
            @if (dish.displayCounter && dish.counter) {
              <ion-item class="countername" lines="none">
                <ion-thumbnail class="category-icon" slot="start">
                  <img src="assets/canteen/categories/{{ dish.category }}.svg" (error)="hideImage($event)" alt="Icon Kategorie {{ dish.category }}" />
                </ion-thumbnail>
                <ion-label class="ion-text-wrap counter">
                  {{ dish.counter }}
                </ion-label>
              </ion-item>
            }
            @if (dish.displayCounter && !dish.counter) {
              <ion-item class="countername">
                <ion-label class="ion-text-wrap counter">
                  {{ 'canteen.otherCounter' | translate }}
                </ion-label>
              </ion-item>
            }
            <ion-item (click)="openDishDetails(dish)" [detail]="!!dish.additives && !!dish.additives.length" [button]="!!dish.additives && !!dish.additives.length">
              <ion-label class="ion-text-wrap">
                <h2>{{ filterAdditives(canteenService.getLocalizedString(dish.title)) }}</h2>
                <p>
                  @for (type of dish.type; track type) {
                    <span>
                      @if (canteenService.getPictogram(type)) {
                        <img
                          class="type"
                          height="20px"
                          role="img"
                          [alt]="type"
                          [src]="canteenService.getPictogram(type)"
                          />
                      }
                    </span>
                  }
                </p>
                <p>
                  @if (dish.price.student !== '0,00 €') {
                    <span class="price">S: {{ dish.price.student }}</span>
                  }
                  @if (dish.price.staff !== '0,00 €') {
                    <span class="price">B: {{ dish.price.staff }}</span>
                  }
                  @if (dish.price.guest !== '0,00 €') {
                    <span class="price">G: {{ dish.price.guest }}</span>
                  }
                </p>
              </ion-label>
            </ion-item>
          }
        </ion-list>
        <div class="ion-text-center ion-padding-top">
          @if (weekday.dishes && weekday.dishes.length) {
            <div>
              <div>
                {{ 'canteen.poweredBy' | translate }}
              </div>
              <img id="logo-stwdo" (click)="openStwdoUrl()" class="logo ion-padding-top" src="assets/canteen/logos/stwdo.svg"  alt="Logo Studentenwerk Dortmund"/>
              <div class="ion-padding-top ion-padding-bottom">
                {{ 'canteen.disclaimer' | translate }}
              </div>
            </div>
          } @else {
            <div>
              {{ 'canteen.menuNotAvailable' | translate }}
            </div>
          }
        </div>
      </swiper-slide>
    }
  </swiper-container>
</ion-content>
